var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"table-header-sort-select",attrs:{"items":_vm.menuItems,"value":_vm.sortVal,"placeholder":"Sort","dense":"","hide-details":"","outlined":"","single-line":"","clearable":""},on:{"change":_vm.updateSortVal}})}
var staticRenderFns = []

export { render, staticRenderFns }